import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
//import {  getCartId,getAuthToken } from '../../utils/auth';

 
 
export const fetchTrackingDetails = createAsyncThunk('common/submitNumber', async (tNumber: {trackingNumber}) => {
    const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/common/order_tracking', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ tracking_number: tNumber.trackingNumber}) // Amount in paise
    });
    return response.json(); 
});

 
export const fetchGlobalSearchDetails = createAsyncThunk('common/submitGlobalSearch', async (searchTxt: {globalSearchTxt,selectedPage}) => {
    const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/products/global_search?page='+searchTxt.selectedPage+'&searchTxt='+searchTxt.globalSearchTxt, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return response.json(); 
});

export const updateProductViewCount = createAsyncThunk('common/productViewCount', async (product_id:string) => {
    const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/common/'+ product_id +'/update_product_view_count', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        }
    });
    return response.json(); 
});
// export const fetchGlobalSearchDetails = createAsyncThunk('common/submitGlobalSearch', async (searchTxt: {globalSearchTxt}) => {
//     const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/products/global_search?page=', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ searchTxt: searchTxt.globalSearchTxt}) // Amount in paise
//     });
//     return response.json(); 
// });
 
 
// Slice
const commonSlice = createSlice({
    name: 'common',
    initialState: { 
        loading: false,
        formErrors: [],
        error: '',
        trackingDetails: [],
        searchResults: [],
        isGlobalSearchOpen: false,
        resultsCurrentPage: 1,
        globalSearchTxt: '',
        resultsTotalPages: 0
    },
    reducers: {
        globalSearchClose: (state) => {
            state.isGlobalSearchOpen = false;
        }
    },
    extraReducers: (builder) => {
        builder
             
        .addCase(fetchTrackingDetails.pending, (state) => {
            state.loading = true;
            state.error = '';
            state.trackingDetails = [];
            state.formErrors = []
            state.isGlobalSearchOpen = false;
        })
        .addCase(fetchTrackingDetails.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload.status === "success"){
                state.formErrors = []
                state.trackingDetails = action.payload.data;
                state.error = '';
                state.isGlobalSearchOpen = false;
            }
            else{
                state.formErrors = action.payload.msg;
            }
        })
        .addCase(fetchTrackingDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = '';
            state.trackingDetails = [];
            state.formErrors = []
            state.isGlobalSearchOpen = false;
        })
         
        .addCase(fetchGlobalSearchDetails.pending, (state) => {
            state.loading = true;
            state.error = '';
            state.searchResults = [];
            state.formErrors = []
            state.isGlobalSearchOpen = false;
            state.resultsCurrentPage = 0;
            state.resultsTotalPages = 0;
            state.globalSearchTxt = '';
        })
        .addCase(fetchGlobalSearchDetails.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload.status === "success"){
                state.formErrors = []
                state.searchResults = action.payload.data;
                state.error = '';
                state.isGlobalSearchOpen = true;
                state.resultsCurrentPage = action.payload.current_page;
                state.resultsTotalPages = action.payload.total_pages;
                state.globalSearchTxt = action.payload.searchTxt;
            }
            else{
                state.formErrors = action.payload.msg;
                state.isGlobalSearchOpen = false;
            }
        })
        .addCase(fetchGlobalSearchDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = '';
            state.trackingDetails = [];
            state.formErrors = []
            state.isGlobalSearchOpen = false;
            state.resultsCurrentPage = 0;
            state.resultsTotalPages = 0;
            state.globalSearchTxt = '';
        })
        
        .addCase(updateProductViewCount.pending, (state) => {
            state.loading = true;
            state.error = ''; 
        })
        .addCase(updateProductViewCount.fulfilled, (state, action) => {
            state.loading = false;
        })
        .addCase(updateProductViewCount.rejected, (state, action) => {
            state.loading = false;
            state.error = ''; 
        })
    }   
});

//export const {  } = customSlice.actions;
export const { globalSearchClose } = commonSlice.actions;

export default commonSlice.reducer;
